import { AfterContentInit, Component,ElementRef,ViewChild, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {
  authToken = localStorage.getItem('auth');
  businessID: string = this.route.snapshot.params.businessID;
  messages = [];
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };
  userID = this.authService.getTokenData().userID;
  currentActiveUser;
  currentUserId = this.authService.getTokenData().userID;
  messageList = [];
  sidebar_open = false;
  employerData;
  @ViewChild("chatMessageContainer", { static: true }) chatMessageContainer: ElementRef;

  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private route:ActivatedRoute,
    private http: HttpClient,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.employerMessageLists();
  }

  ngOnDestroy(){
    localStorage.removeItem('ACTIVE_MSG_LIST');
  }

  employerMessageLists() {
    var active_msg_list = JSON.parse(localStorage.getItem('ACTIVE_MSG_LIST'));
    var query_string = '';
    if(active_msg_list){
      query_string = '?active_msg_list=' + active_msg_list;
    }

    this.http.get(environment.EMPLOYER_MESSAGE_LISTS+query_string, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          var messages = res.message;
          var unRead = [];
          var read = [];
          var empty = [];

          //Calculate unread messages and expiracy


          for (let i = 0; i < messages.length; i++) {
            var msg_list = messages[i];
            console.log(msg_list);
            msg_list.unreadMessages = 0;
            msg_list.expired = false;
            if(msg_list.messages.length == 0){
              empty.push(msg_list);
            }

            for (let j = 0; j < msg_list.messages.length; j++) {
              var msg = msg_list.messages[j];

              if(msg.from != this.userID && msg.reciever_has_read == false){
                msg_list.unreadMessages = msg_list.unreadMessages + 1;
                unRead.push(msg_list);
              }

              if(j+1 == msg_list.messages.length && msg_list.unreadMessages == 0){
                read.push(msg_list);
              }

            }


            //Sort unread by date
            unRead.sort(function(a, b) {
              var dateA = new Date(a.createdDate)
              var dateB = new Date(b.createdDate);
              return dateB.getTime() - dateA.getTime();
            });

            //Sort read by date
            read.sort(function(a, b) {
              var dateA = new Date(a.createdDate)
              var dateB = new Date(b.createdDate);
              return dateB.getTime() - dateA.getTime();
            });


            //Merge unread and read
            this.messages = unRead.concat(read);
            this.messages = this.messages.concat(empty);

            //Count expiracy create date + 30 days - current date
            var date = new Date();
            var epoch = date.getTime();
            var create_date = new Date(msg_list.createdDate);
            var epoch_create_date = create_date.getTime();
            var diff = epoch - epoch_create_date;
            var days = diff / (1000 * 3600 * 24);
            msg_list.days = 30 - Math.round(days);

          }

          //Set active user as the first user
          if(this.messages.length > 0){
            var active_msg_list = JSON.parse(localStorage.getItem('ACTIVE_MSG_LIST'));
            if(active_msg_list){
              
              console.log(active_msg_list, 'active_msg_list')
              //Now find corresponding userData from messages
              var has_found = false;
              for (let i = 0; i < this.messages.length; i++) {
                const element = this.messages[i];
                if(element['_id'] == active_msg_list){
                  this.currentActiveUser = element['user'];
                  has_found = true;
                }
              }

              if(!has_found){
                this.currentActiveUser = this.messages[0]['user'];
                this.fetchMessageLists(this.messages[0]['_id']);
              }
              else{
                this.fetchMessageLists(active_msg_list);

              }

            }
            else{
              this.currentActiveUser = this.messages[0]['user'];
              this.fetchMessageLists(this.messages[0]['_id']);
              console.log(this.currentActiveUser, 'currentActiveUser')
            }
          }
          else{
            this.currentActiveUser = null;
          }


        }
        else {
          this.messages = []
        }
        
      }, (err: any) => {

      }
    )
  }

  fetchMessageLists(userID){

  
      
    this.http.get(environment.MESSAGE_LISTS + '/' + userID, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.employerData = res.message[0]['employer'];

          this.setActiveMsgList(userID);

          //Calculate unread messages
          for (let i = 0; i < res.message.length; i++) {
            var msg_list = res.message[i];
            msg_list.unreadMessages = 0;

            for (let j = 0; j < msg_list.messages.length; j++) {
              var msg = msg_list.messages[j];

              if(msg.senderID != this.currentUserId && msg.reciever_has_read == false){
                msg_list.unreadMessages = msg_list.unreadMessages + 1;
              }
              
            }
            
          }

          this.messageList  = res.message[0];
          console.log(this.messageList, 'messageList')
          this.currentActiveUser = this.messageList['user'];
          console.log(this.messageList['user'], 'Käutt');


          setTimeout(() => {
            this.scrollToBottom();
          },400)

        }
      else {
          
        }
      }, (err: any) => {

        console.log("Error while login :: ", err);
      }
    )
}

setActiveMsgList(userID){
  //remove active msg class from all
  var elems = document.querySelectorAll(".active-msg-list");
  [].forEach.call(elems, function(el) {
    el.classList.remove("active-msg-list");
  });


  //Now add active msg class to clicked
  var elem = document.getElementById('message-list-'+userID);
  elem.classList.add("active-msg-list");




}

selectUser(user){
  if(this.currentActiveUser['_id'] == user['_id']){
    this.currentActiveUser = user;
    
    this.fetchMessageLists(user._id);
    this.closeSideBar();
  }
  else{
    console.log('same', user);
    //Check if messagelist is same as current
    if(this.messageList['_id'] == user['_id']){
      console.log('same message list')
      this.closeSideBar();
    }
    else{
      console.log('different message list')
      this.fetchMessageLists(user._id);
      this.closeSideBar();

    }
  }
}

private scrollToBottom(): void {

  try {
    //smoothscroll.polyfill();
    this.chatMessageContainer.nativeElement.scrollTo({ top: this.chatMessageContainer.nativeElement.scrollHeight, behavior: 'smooth' })
    //this.SmoothVerticalScrolling(this.chatMessageContainer, 300, "bottom")
    // this.myScrollContainer.nativeElement.scroll
    //this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
  } catch (err) { }
}

OnSendReply(){

  //check if message is empty
  var value = (<HTMLInputElement>document.getElementById("comment")).value;
  //remove spaces and check if empty
  if(value.replace(/\s/g, '') == ''){
    alert('Viesti ei voi olla tyhjä');
    return;
  }


  var message = (<HTMLInputElement>document.getElementById("comment")).value;
  var req = {
    message: message,
    messageListID: this.messageList['_id'],
    to: this.currentActiveUser['_id'],
    files: null,
  }

  this.http.post(environment.MESSAGE_LISTS + "/" + this.messageList['_id'] + '/saveMessage', req,this.httpOptions).subscribe(
    (res: any) => {
      if (res.status == 200) {
        this.messageList['messages'].push(res.message);
        (<HTMLInputElement>document.getElementById("comment")).value = "";
        //COMMENT HEIGHT BACK TO NORMAL
        document.getElementById('comment').setAttribute('style', 'height:40px!important')
        document.getElementById('main-chat-container').style.marginTop = "0px";

        //push message messages array
        var msg_obj = {
          createdDate: res.message.createdDate,
        }
        for (let i = 0; i < this.messages.length; i++) {
          var msgl = this.messages[i];

          if(msgl['_id'] == this.messageList['_id']){
            console.log('found')
            console.log(this.messages[i])
            this.messages[i]['messages'][0] = res.message;
          }

          
          
        }

        setTimeout(() => {
          this.scrollToBottom();

        },200)
      }
     else {
        alert('Viestin tallennuksessa kävi virhe');
      }
    }
  )
}

autoTextarea(e){
  var textarea = document.getElementById("comment");
  var main = document.getElementById("main");
  var heightLimit = 500; /* Maximum height: 200px */

  textarea.oninput = function() {
    textarea.style.height = ""; /* Reset the height*/
    textarea.style.height = Math.min(textarea.scrollHeight, heightLimit) + "px";
    textarea.setAttribute('style', 'height:' +Math.min(textarea.scrollHeight, heightLimit)+'px!important')

    document.getElementById('main-chat-container').style.marginTop = "0px";
    document.getElementById('main-chat-container').style.marginTop = "-" + (document.getElementById('comment').clientHeight - 40).toString() + "px";
  };
}

removeMessageList(){
  console.log(this.currentActiveUser)
  var current_msg_list_id = this.messageList['_id'];

  this.http.delete(environment.MESSAGE_LISTS + '/' + current_msg_list_id, this.httpOptions).subscribe(
    (res: any) => {
      if (res.status == 200) {
        console.log('deleted')
        document.getElementById('close-modal-open').click();
        //clear localstorage
        localStorage.removeItem('ACTIVE_MSG_LIST');
        //clear currentActiveUSer
        this.currentActiveUser = null;
        //clear messageList
        this.messageList = [];
        this.employerMessageLists();
      }
     else {
        alert('Viestin poistossa kävi virhe');
      }
    }
  )
}

openSideBar(){
  var messageView = document.getElementById('message-view');
  var listingView = document.getElementById('message-listing');

  messageView.classList.add('d-none');
  listingView.classList.remove('d-none');
  this.sidebar_open = true;
}

closeSideBar(){
  var messageView = document.getElementById('message-view');
  var listingView = document.getElementById('message-listing');

  messageView.classList.remove('d-none');
  listingView.classList.add('d-none');
  this.sidebar_open = false;
}

}
